// CUSTOMIZATION from slot in io-visit:
// array for suited to field

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { Icon } from '@redturtle/iovisit-theme/components';

const messages = defineMessages({
  starting_from: { id: 'itinerary_start_from', defaultMessage: 'Partenza da' },
  tour_length: { id: 'itinerary_tour_length', defaultMessage: 'Lunghezza' },
  duration: { id: 'itinerary_duration', defaultMessage: 'Durata' },
  suitable_for: { id: 'itinerary_suitable_for', defaultMessage: 'Adatto a' },
});

const FTASummaryInfos = ({ content }) => {
  const intl = useIntl();

  const suited_to = () => {
    if (!content?.suited_to?.length) return null;
    return content.suited_to.map((el) => el.title).join(', ');
  };

  return (
    <div className="leadimage-more">
      <Container>
        <div className="itinerary-infos">
          {content?.starting_from && (
            <div className="info">
              <Icon prefix="fas" icon="map-pin" className="icon" />
              <div className="title">
                {intl.formatMessage(messages.starting_from)}
              </div>
              <div className="value">{content?.starting_from}</div>
            </div>
          )}

          {content?.tour_length && (
            <div className="info">
              <Icon prefix="fas" icon="arrows-alt-h" className="icon" />
              <div className="title">
                {intl.formatMessage(messages.tour_length)}
              </div>
              <div className="value">{content?.tour_length}</div>
            </div>
          )}

          {content?.duration && (
            <div className="info">
              <Icon prefix="fas" icon="stopwatch" className="icon" />
              <div className="title">
                {intl.formatMessage(messages.duration)}
              </div>
              <div className="value">{content?.duration}</div>
            </div>
          )}

          {content?.suited_to?.length > 0 && (
            <div className="info">
              <Icon prefix="fas" icon="users" className="icon" />
              <div className="title">
                {intl.formatMessage(messages.suitable_for)}
              </div>
              <div className="value">{suited_to()}</div>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default FTASummaryInfos;
